/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

interface IViewTrackingButtonProps {
    innerReference?: React.RefObject<HTMLButtonElement>;
    className: string;
    viewTrackingButtonLabel?: string;
    onClicked(): void;
}

export const ViewTrackingButton: React.FC<IViewTrackingButtonProps> = ({
    className,
    onClicked,
    viewTrackingButtonLabel,
    innerReference
}) => {
    return (
        <Button className={`${className}__viewTrackingButton`} onClick={onClicked} innerRef={innerReference}>
            {viewTrackingButtonLabel}
        </Button>
    );
};
